/**
 * Put a day column in the middle of the register's scroll region.
 * Uses offsets rather than scrollIntoView so the page itself doesn't jump.
 */
export function scrollToCenter(container: HTMLElement, target: HTMLElement): void {
  const left = target.offsetLeft - (container.clientWidth - target.offsetWidth) / 2;
  container.scrollLeft = Math.max(0, left);
}
